module.exports = __webpack_public_path__ + "static/4-3bfd650f0611bfbae73c0fa851837660.jpg";